<template>
  <a-modal :visible="true" title="添加公告" @ok="sub" @cancel="cancel">
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="分类">
        <a-select v-model="cate_id" @change="selectCate">
          <a-select-option v-for="(cate, index) in cateList" :value="cate.id" :key="index">{{
            cate.cate_name
          }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="文章">
        <a-select v-model="form.article_id">
          <a-select-option
            v-for="(article, index2) in articleList"
            :value="article.id"
            :key="index2"
            >{{ article.title }}</a-select-option
          >
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang='scss' scoped>
</style>

<script>
import moment from "moment";
export default {
  props: ["exh_id"],
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      cateList: [],
      cate_id: 0,
      articleList: [
        {
          id: 0,
          title: "请选择",
        },
      ],
      form: {
        exh_id: null,
        article_id: 0,
      },
    };
  },
  created() {
    this.form.exh_id = this.exh_id;
    this.getCateList();
  },
  methods: {
    moment,
    async getCateList() {
      // 获取所有的资料分类
      const r = await this.$axios.get("/article/getCateList?type=1");

      if (r.status == 1) {
        r.list.unshift({
          id: 0,
          cate_name: "所有类别",
        });
        this.cateList = r.list;
      }
    },

    async selectCate() {
      const r = await this.$axios.get(
        "/article/getArticlesByCate?cate_id=" + this.cate_id
      );

      if (r.status == 1) {
        r.list.unshift({
          id: 0,
          title: "请选择",
        });
        this.articleList = r.list;
      }
    },

    async sub() {
      if (!this.form.exh_id) return this.$message.error("未找到贝展id");
      if (!this.form.article_id) return this.$message.error("请选择文章");

      const r = await this.$axios.post("/notice/bind", this.form);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>